import { render, staticRenderFns } from "./BuySuccess.vue?vue&type=template&id=6d29924e&scoped=true&"
import script from "./BuySuccess.vue?vue&type=script&lang=js&"
export * from "./BuySuccess.vue?vue&type=script&lang=js&"
import style0 from "./BuySuccess.vue?vue&type=style&index=0&id=6d29924e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d29924e",
  null
  
)

export default component.exports